"use client";
import styles from "./courseData.module.scss";
import { LevelComponent } from "../LevelComponent/levelComponent";
import { useState } from "react";
import FormComponent from "../FormComponent/formComponent";
import ButtonComponent from "../ButtonComponent/buttonComponent";
import { CallUsAt } from "../CallUsAtComponent/callUsAt";
import { promAxios } from "../../../store/promAxios";
import { reduxStateUpdateAddOrder } from "../../../store/common.reducer";
import { getCourseDurationString, getRandomString, isCourseAlreadySubscribed } from "../../util/utils";

import { useNavigate } from "react-router-dom";

const ListComponent = (props) => {
    const { title, points = [] } = props;

    return (
        <div className={styles.detailsContainer}>
            {title ? <div className={styles.title}>{title}</div> : null}

            {points?.length > 0 ? (
                <div className={styles.listContainer}>
                    <ul className={styles.list}>
                        {points?.map((point) => (
                            <li className={styles.listItem} key={point}>
                                {point}
                            </li>
                        ))}
                    </ul>
                </div>
            ) : null}
        </div>
    );
};

const CourseModuleItem = (props) => {
    const { data, itemIndex, onExpandItem, expandedItems } = props;
    const getCountInfo = () => {
        let lessonsCount = 0;
        let exercisesCount = 0;
        let examsCount = 0;

        data?.tasks?.forEach((task) => {
            if (task?.taskType?.toLowerCase()?.includes("lesson")) {
                lessonsCount += 1;
            } else if (task?.taskType?.toLowerCase()?.includes("exercise")) {
                exercisesCount += 1;
            } else if (task?.taskType?.toLowerCase()?.includes("exam")) {
                examsCount += 1;
            }
        });
        return {
            lessonsCount,
            exercisesCount,
            examsCount,
        };
    };
    const { lessonsCount, exercisesCount, examsCount } = getCountInfo();
    const isItemExpanded = expandedItems?.includes(itemIndex);
    return (
        <div className={styles.courseModulesItem}>
            <div
                className={styles.courseModulesItemHeader}
                tabIndex={0}
                role="button"
                onClick={() => onExpandItem(itemIndex)}
            >
                <div className={styles.courseModuleName}>
                    <div>
                        {isItemExpanded ? (
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z"
                                    fill="#888888"
                                />
                            </svg>
                        ) : (
                            <svg
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.41 0.580078L6 5.17008L10.59 0.580078L12 2.00008L6 8.00008L0 2.00008L1.41 0.580078Z"
                                    fill="#888888"
                                />
                            </svg>
                        )}
                    </div>
                    <div>{data?.moduleName}</div>
                </div>

                <div className={styles.courseCountInfo}>
                    {lessonsCount > 0 ? (
                        <span>
                            {`${lessonsCount} lesson${lessonsCount > 1 ? `s` : ``}`}
                        </span>
                    ) : null}
                    {exercisesCount > 0 ? (
                        <span>
                            {`${exercisesCount} exercise${exercisesCount > 1 ? `s` : ``}`}
                        </span>
                    ) : null}
                    {examsCount > 0 ? (
                        <span>{`${examsCount} exam${examsCount > 1 ? `s` : ``}`}</span>
                    ) : null}
                </div>
            </div>

            {isItemExpanded ? (
                <div className={styles.courseModuleInfo}>
                    {data?.moduleDescriptionHtml || "-"}
                </div>
            ) : null}
        </div>
    );
};

const RegisterCourseComponent = (props) => {
    const { item, showImage = true, course, allSubscriptions } = props;
    const { courseBannerUrl, courseName } = item;
    const navigate = useNavigate()

    const isAlreadyRegistered = isCourseAlreadySubscribed({
        allSubscriptions,
        courseId: course?.courseId
    })
    return (
        <div className={styles.registerComponent} style={{width: "20rem"}}>
            {/* {showImage && (
                <img
                    className={styles.courseImage}
                    src={courseBannerUrl}
                    alt={courseName}
                />
            )}
            <FormComponent /> */}

            {!isAlreadyRegistered && course?.modules?.filter(
                module => module.isTrialModule)?.length > 0 ? <ButtonComponent 
            className={styles.registerButton} type="dark" onClick={() => {
                navigate(`/courses?courseId=${course.courseId}`);
                // window.location.href = `/courses?courseId=${course?.courseId}`
            }}>
                Try now
            </ButtonComponent>: null}

            {!isAlreadyRegistered ? <ButtonComponent className={styles.registerButton} type="dark" 
                onClick={() => {
                if (course?.onlineRegistrationStatus !== "open") {
                    return
                }
                
                navigate(`/app/register?courseId=${course.courseId}`)
                // onCreateOrder({
                //     orderItems: [{
                //         orderItemId: getRandomString(),
                //         orderItemType: "courseFee",
                //         courseId: course.courseId,
                //         price: course.price
                //     }]
                // })
            }}>
                {course?.onlineRegistrationStatus === "open" ? "Register": "Online access coming soon"}
            </ButtonComponent>: null}

            {isAlreadyRegistered ? <ButtonComponent 
            className={styles.registerButton} type="dark" onClick={() => {
                navigate(`/courses?courseId=${course.courseId}`);
                // window.location.href = `/courses?courseId=${course?.courseId}`
            }}>
                Go to Course
            </ButtonComponent>: null}
        </div>
    );
};

export const CourseData = (props) => {
    const [expandedList, setExpandedList] = useState([0]);
    const { details, course, allSubscriptions } = props;
    const getCourseString = () => {
        return getCourseDurationString(details?.courseDuration || {})
        // const { min, max, unit } = details?.courseDuration || {};
        // let courseString = "";
        // if (min) {
        //     courseString += min;
        // }
        // if (max) {
        //     courseString += ` - ${max} `;
        // }
        // if (unit) {
        //     courseString += unit;
        // }
        // return courseString;
    };

    const onExpandItem = (index) => {
        // To disable multiple item expansion please change the flag in en.json
        const isMultiSelectionAllow = true;

        if (isMultiSelectionAllow) {
            if (expandedList?.includes(index)) {
                setExpandedList((prevState) =>
                    prevState?.filter((item) => item !== index)
                );
            } else {
                setExpandedList((expandedList) => [...expandedList, index]);
            }
        } else {
            setExpandedList([index]);
        }
    };

    const onExpandAllItem = () => {
        if (expandedList?.length === details?.modules?.length) {
            setExpandedList([]);
        } else {
            const expandAllItem = details?.modules?.map((item, index) => index);
            setExpandedList(expandAllItem);
        }
    };
    return (
        <div className={styles.container}>
            <div className={styles.topHeaderContainer}>
                <div className={styles.leftSideContainer}>
                    <div className={styles.headerTitle}>{details?.courseName}</div>
                    <div className={styles.subText}>{details?.courseDescriptionHtml}</div>
                    <div className={styles.subInfo}>
                        <LevelComponent level={details?.level} />
                        <div className={styles.timePeriod}>
                            <svg
                                width="16"
                                height="18"
                                viewBox="0 0 16 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2.16667 17.3332C1.70833 17.3332 1.31597 17.17 0.989583 16.8436C0.663194 16.5172 0.5 16.1248 0.5 15.6665V3.99984C0.5 3.5415 0.663194 3.14914 0.989583 2.82275C1.31597 2.49637 1.70833 2.33317 2.16667 2.33317H3V0.666504H4.66667V2.33317H11.3333V0.666504H13V2.33317H13.8333C14.2917 2.33317 14.684 2.49637 15.0104 2.82275C15.3368 3.14914 15.5 3.5415 15.5 3.99984V15.6665C15.5 16.1248 15.3368 16.5172 15.0104 16.8436C14.684 17.17 14.2917 17.3332 13.8333 17.3332H2.16667ZM2.16667 15.6665H13.8333V7.33317H2.16667V15.6665ZM2.16667 5.6665H13.8333V3.99984H2.16667V5.6665ZM8 10.6665C7.76389 10.6665 7.56597 10.5866 7.40625 10.4269C7.24653 10.2672 7.16667 10.0693 7.16667 9.83317C7.16667 9.59706 7.24653 9.39914 7.40625 9.23942C7.56597 9.0797 7.76389 8.99984 8 8.99984C8.23611 8.99984 8.43403 9.0797 8.59375 9.23942C8.75347 9.39914 8.83333 9.59706 8.83333 9.83317C8.83333 10.0693 8.75347 10.2672 8.59375 10.4269C8.43403 10.5866 8.23611 10.6665 8 10.6665ZM4.66667 10.6665C4.43056 10.6665 4.23264 10.5866 4.07292 10.4269C3.91319 10.2672 3.83333 10.0693 3.83333 9.83317C3.83333 9.59706 3.91319 9.39914 4.07292 9.23942C4.23264 9.0797 4.43056 8.99984 4.66667 8.99984C4.90278 8.99984 5.10069 9.0797 5.26042 9.23942C5.42014 9.39914 5.5 9.59706 5.5 9.83317C5.5 10.0693 5.42014 10.2672 5.26042 10.4269C5.10069 10.5866 4.90278 10.6665 4.66667 10.6665ZM11.3333 10.6665C11.0972 10.6665 10.8993 10.5866 10.7396 10.4269C10.5799 10.2672 10.5 10.0693 10.5 9.83317C10.5 9.59706 10.5799 9.39914 10.7396 9.23942C10.8993 9.0797 11.0972 8.99984 11.3333 8.99984C11.5694 8.99984 11.7674 9.0797 11.9271 9.23942C12.0868 9.39914 12.1667 9.59706 12.1667 9.83317C12.1667 10.0693 12.0868 10.2672 11.9271 10.4269C11.7674 10.5866 11.5694 10.6665 11.3333 10.6665ZM8 13.9998C7.76389 13.9998 7.56597 13.92 7.40625 13.7603C7.24653 13.6005 7.16667 13.4026 7.16667 13.1665C7.16667 12.9304 7.24653 12.7325 7.40625 12.5728C7.56597 12.413 7.76389 12.3332 8 12.3332C8.23611 12.3332 8.43403 12.413 8.59375 12.5728C8.75347 12.7325 8.83333 12.9304 8.83333 13.1665C8.83333 13.4026 8.75347 13.6005 8.59375 13.7603C8.43403 13.92 8.23611 13.9998 8 13.9998ZM4.66667 13.9998C4.43056 13.9998 4.23264 13.92 4.07292 13.7603C3.91319 13.6005 3.83333 13.4026 3.83333 13.1665C3.83333 12.9304 3.91319 12.7325 4.07292 12.5728C4.23264 12.413 4.43056 12.3332 4.66667 12.3332C4.90278 12.3332 5.10069 12.413 5.26042 12.5728C5.42014 12.7325 5.5 12.9304 5.5 13.1665C5.5 13.4026 5.42014 13.6005 5.26042 13.7603C5.10069 13.92 4.90278 13.9998 4.66667 13.9998ZM11.3333 13.9998C11.0972 13.9998 10.8993 13.92 10.7396 13.7603C10.5799 13.6005 10.5 13.4026 10.5 13.1665C10.5 12.9304 10.5799 12.7325 10.7396 12.5728C10.8993 12.413 11.0972 12.3332 11.3333 12.3332C11.5694 12.3332 11.7674 12.413 11.9271 12.5728C12.0868 12.7325 12.1667 12.9304 12.1667 13.1665C12.1667 13.4026 12.0868 13.6005 11.9271 13.7603C11.7674 13.92 11.5694 13.9998 11.3333 13.9998Z"
                                    fill="white"
                                />
                            </svg>
                            {getCourseString()}
                        </div>
                    </div>
                </div>
                <div className={styles.rightSideContainer}>
                    <RegisterCourseComponent item={details} navigate={props.navigate} course={course}
                    allSubscriptions={allSubscriptions}
                    dispatchFunctionAction={props.dispatchFunctionAction}/>
                </div>
            </div>
            <div className={styles.details}>
                <div className={styles.innerDetails}>
                    {/* <ListComponent
                        title={"Requirements"}
                        points={[
                            "No programming experience needed - we'll teach you everything you need to know",
                            "A computer with access to the internet",
                            "No paid software required",
                            "We'll walk you through, step-by-step how to get all the software installed and set up",
                        ]}
                    /> */}
                    {details?.modules?.length ? (
                        <div className={styles.programPlans}>
                            <div className={styles.cardsTitle}>{"Course Contents"}</div>
                            <div className={styles.cardsSubTitle}>
                                {`${details?.modules?.length} Section${details?.modules?.length > 1 ? `s` : ``
                                    }`}

                                <div
                                    className={styles.expandItemsBtn}
                                    role="button"
                                    tabIndex={0}
                                    onClick={onExpandAllItem}
                                >
                                    {expandedList?.length === details?.modules?.length
                                        ? "Collapse all sections"
                                        : "Expand all sections"}
                                </div>
                            </div>

                            <div className={styles.cardsList}>
                                {details?.modules?.map((module, index) => (
                                    <CourseModuleItem
                                        key={module.moduleId}
                                        itemIndex={index}
                                        data={module}
                                        onExpandItem={onExpandItem}
                                        expandedItems={expandedList}
                                    />
                                ))}
                            </div>
                        </div>
                    ) : null}

                    {/* <div className={styles.detailsContainer}>
                        <div className={styles.title}>Mentors</div>

                        <div className={styles.instructorDetails}>
                            <div className={styles.instructorInfo}>
                                <span className={styles.intructorName}>Anil Muthineni</span>
                                <span className={styles.instructorRole}>Instructor</span>
                            </div>
                            <div className={styles.instructorExperience}>
                                Instructor Experience needs to be written here
                            </div>
                        </div>
                    </div> */}
                </div>
                <div className={styles.registerTabMobContainer}>
                    <RegisterCourseComponent item={details} showImage={false} course={course}
                    allSubscriptions={allSubscriptions}/>
                </div>
            </div>
            <CallUsAt />
        </div>
    );
};
